Object.assign(window.FazendaRP.Pages.financeiro, {

    // Dados iniciais (Populado na primeira execução se vazio)
    // planoContasData: null, // Defined in core.js

    initPlanoContasData: function () {
        // 1. Check if we have robust data (> 10 items)
        if (this.planoContasData && this.planoContasData.length > 10) return;

        // 2. Define Defaults (Fallback)
        const defaults = [
            { codigo: '1', nome: 'Receitas', tipo: 'GRUPO', natureza: 'CREDITO' },
            { codigo: '1.1', nome: 'Venda de Produtos Agrícolas', tipo: 'SUBGRUPO', natureza: 'CREDITO' },
            { codigo: '1.1.1', nome: 'Vendas de Soja', tipo: 'CONTA', natureza: 'CREDITO' },
            { codigo: '1.1.2', nome: 'Vendas de Milho', tipo: 'CONTA', natureza: 'CREDITO' },
            { codigo: '1.1.3', nome: 'Vendas de Sorgo', tipo: 'CONTA', natureza: 'CREDITO' },
            { codigo: '1.2', nome: 'Outras Receitas da Atividade', tipo: 'SUBGRUPO', natureza: 'CREDITO' },
            { codigo: '2', nome: 'Custos e Despesas', tipo: 'GRUPO', natureza: 'DEBITO' },
            { codigo: '2.1', nome: 'Custos de Produção', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.1.1', nome: 'Insumos Agrícolas', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.1.1.1', nome: 'Óleos e Adjuvantes', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.2', nome: 'Fungicidas', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.3', nome: 'Inseticidas', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.4', nome: 'Fertilizantes Foliares', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.5', nome: 'Fertilizantes Químicos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.6', nome: 'Biológicos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.7', nome: 'Sementes', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.8', nome: 'Calcário', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.9', nome: 'Gesso', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.1.10', nome: 'Herbicidas', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.2', nome: 'Mão de Obra Agrícola', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.1.2.1', nome: 'Salários', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.2.2', nome: 'INSS', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.2.3', nome: 'FGTS', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.3', nome: 'Manutenção de Máquinas e Implementos Agrícolas', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.4', nome: 'Manutenção de Equipamentos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.5', nome: 'Compra de outros Materiais', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.6', nome: 'Óleo Diesel', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.7', nome: 'Frete', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.8', nome: 'Alimentação', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.9', nome: 'Mecânica', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.1.10', nome: 'Colheita Terceirizada', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2', nome: 'Despesas Operacionais', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.1', nome: 'Despesas Administrativas', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.1.1', nome: 'Contador', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.2', nome: 'Software de Gestão', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.3', nome: 'Energia', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.4', nome: 'Internet', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.5', nome: 'Despesas com Material de Escritório', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.6', nome: 'Contribuição Sindical', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.1.7', nome: 'Depreciação', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.2', nome: 'Despesas de Vendas', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.2.1', nome: 'Assessoria de Comercialização', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.2.2', nome: 'Armazenamento', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3', nome: 'Outras Despesas', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.3.1', nome: 'Despesas com Combustível', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.3.1.1', nome: 'Diesel S10', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.1.2', nome: 'Gasolina', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.1.3', nome: 'Etanol', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.2', nome: 'Despesas com Manutenção', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.2.3.2.1', nome: 'Despesas de Manutenção de Edificações Rurais', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.2.2', nome: 'Despesas de Máquinas e Equipamentos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.2.3', nome: 'Despesas com Ferramentas e Peças de Reposição', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.2.4', nome: 'Despesas com Manutenção de Veículos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.3', nome: 'Despesa com Frete', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.4', nome: 'Gratificações', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.5', nome: 'Outras Despesas', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.6', nome: 'Lava Jato', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.7', nome: 'Arrendamento', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.2.3.8', nome: 'Despesas com Mecânica', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.3', nome: 'Despesas não Operacionais', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.3.1', nome: 'Despesas com o Judiciário', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.3.2', nome: 'Honorários Advocatícios', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.3.3', nome: 'Despesas com a Sede', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.4', nome: 'Despesas Financeiras', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.4.1', nome: 'Juros', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.4.2', nome: 'IOF', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.4.3', nome: 'Acessórios', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.4.4', nome: 'Taxa Bancária', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.4.5', nome: 'Corretagem e Emolumentos', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.5', nome: 'Participações nos Resultados', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.5.1', nome: 'Participações José Castilho', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.5.2', nome: 'Participações Pedro Paulo', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.6', nome: 'Deduções da Receita Bruta', tipo: 'SUBGRUPO', natureza: 'DEBITO' },
            { codigo: '2.6.1', nome: 'Funrural', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.6.2', nome: 'Senar', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.6.3', nome: 'ICMS', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '2.6.4', nome: 'Fundeinfra', tipo: 'CONTA', natureza: 'DEBITO' },
            { codigo: '3', nome: 'Outras Receitas', tipo: 'GRUPO', natureza: 'CREDITO' },
            { codigo: '3.1', nome: 'Receitas não Operacional', tipo: 'SUBGRUPO', natureza: 'CREDITO' },
            { codigo: '3.1.1', nome: 'Descontos Obtidos', tipo: 'CONTA', natureza: 'CREDITO' },
            { codigo: '3.2', nome: 'Lucros e Dividendos de Investimento', tipo: 'SUBGRUPO', natureza: 'CREDITO' }
        ];

        // 3. Merge currently loaded data (DB) with defaults
        const current = this.planoContasData || [];

        // Add defaults if they are missing
        defaults.forEach(d => {
            const exists = current.some(c => c.codigo === d.codigo);
            if (!exists) {
                current.push(d);
            }
        });

        // 4. Sort (Numeric Segment-based)
        current.sort((a, b) => {
            const partsA = a.codigo.split('.').map(Number);
            const partsB = b.codigo.split('.').map(Number);
            const len = Math.max(partsA.length, partsB.length);

            for (let i = 0; i < len; i++) {
                const valA = partsA[i] || 0; // Treat missing segments as 0 (parent comes first)
                const valB = partsB[i] || 0;
                if (valA !== valB) return valA - valB;
            }
            return 0;
        });

        this.planoContasData = current;
    },

    getPlanoContasOptionsHTML: function () {
        this.initPlanoContasData();
        return this.planoContasData.map(c => {
            return `<option value="${c.codigo} - ${c.nome}">`;
        }).join('');
    },

    renderPlanoContas: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:30px;"><i class="fas fa-spinner fa-spin"></i> Carregando Plano de Contas...</div>';

        // 1. Load Data from DB
        const { data: lista, error } = await window.FazendaRP.supabase
            .from('financeiro_plano_contas')
            .select('*')
            .order('codigo');

        if (error) {
            container.innerHTML = `<div style="color:red; text-align:center; padding: 20px;">Erro: ${error.message}</div>`;
            return;
        }

        this.planoContasData = lista || [];

        // Correct Sort (Numeric Segment-based) - Fixes 2.1.10 appearing before 2.1.2
        this.planoContasData.sort((a, b) => {
            const partsA = a.codigo.split('.').map(Number);
            const partsB = b.codigo.split('.').map(Number);
            const len = Math.max(partsA.length, partsB.length);

            for (let i = 0; i < len; i++) {
                const valA = partsA[i] || 0;
                const valB = partsB[i] || 0;
                if (valA !== valB) return valA - valB;
            }
            return 0;
        });

        // 2. Prepare Parent Options (para o Select de "Conta Pai")
        // Apenas Grupos e Subgrupos podem ser pais
        const parents = this.planoContasData.filter(c => c.tipo !== 'CONTA' && c.tipo !== 'ANALITICA');
        const parentsOpts = parents.map(c => `<option value="${c.codigo}" data-nat="${c.natureza}">${c.codigo} - ${c.nome}</option>`).join('');

        container.innerHTML = `
            <div class="data-table-container">
                <div class="action-bar" style="justify-content: flex-end;">
                    <button id="btn-nova-conta" class="btn btn-primary">+ Nova Conta</button>
                </div>
                
                <table class="data-table" id="tabela-plano-contas">
                    <thead>
                        <tr>
                            <th width="100">Código</th>
                            <th>Nome da Conta</th>
                            <th width="120">Tipo</th>
                            <th width="120">Natureza</th>
                            <th width="150">Classificação Balanço</th>
                            <th width="100">Ações</th>
                        </tr>
                    </thead>
                    <tbody id="tbody-plano">
                        <!-- JS Generated -->
                    </tbody>
                </table>
            </div>
            
            <div id="modal-nova-conta" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; align-items: center; justify-content: center;">
                <div style="background: white; width: 500px; padding: 25px; border-radius: 8px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                        <h3 style="margin: 0;">Nova Conta Contábil</h3>
                        <button type="button" id="btn-close-modal" style="background: none; border: none; font-size: 1.5rem; cursor: pointer;">&times;</button>
                    </div>
                    
                    <form id="form-nova-conta">
                        <!-- Seleção do Pai (para gerar código) -->
                        <div class="form-group" style="margin-bottom: 15px;">
                            <label>Conta Pai (Grupo Superior)</label>
                            <select id="pc-pai" class="form-control" required style="width: 100%; background-color: #f8fafc;">
                                <option value="">-- Selecione para Gerar Código --</option>
                                ${parentsOpts}
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Código da Conta * <i class="fas fa-lock" style="font-size: 0.8em; color: #9ca3af;" title="Gerado automaticamente"></i></label>
                            <input type="text" id="pc-codigo" placeholder="Selecione a Conta Pai acima..." required readonly style="width: 100%; font-weight: bold; color: #2563eb; background-color: #f3f4f6; cursor: not-allowed;">
                        </div>
                         <div class="form-group">
                            <label>Nome da Conta *</label>
                            <input type="text" id="pc-nome" placeholder="Ex: Sementes" required style="width: 100%;">
                        </div>
                        <div class="form-group">
                            <label>Tipo *</label>
                            <select id="pc-tipo" style="width: 100%;">
                                <option value="ANALITICA" selected>ANALÍTICA (Lançamentos)</option>
                                <option value="SUBGRUPO">SUBGRUPO (Agrupador)</option>
                                <option value="GRUPO">GRUPO (Raiz)</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Natureza *</label>
                            <select id="pc-natureza" style="width: 100%; pointer-events: none; background: #eee;">
                                <option value="DEBITO">Débito (Despesas)</option>
                                <option value="CREDITO">Crédito (Receitas)</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Classificação Balanço <i class="fas fa-scale-balanced" style="color: #059669;"></i></label>
                            <select id="pc-tipo-balanco" style="width: 100%;">
                                <option value="">-- Nenhuma --</option>
                                <optgroup label="ATIVO">
                                    <option value="ativo_circulante">Ativo Circulante (Curto Prazo)</option>
                                    <option value="ativo_realizavel">Ativo Realizável (Longo Prazo)</option>
                                    <option value="ativo_imobilizado">Ativo Imobilizado</option>
                                </optgroup>
                                <optgroup label="PASSIVO">
                                    <option value="passivo_circulante">Passivo Circulante (Curto Prazo)</option>
                                    <option value="passivo_nao_circulante">Passivo Não Circulante (Longo Prazo)</option>
                                    <option value="patrimonio_liquido">Patrimônio Líquido</option>
                                </optgroup>
                            </select>
                        </div>
                        
                        <div style="text-align: right; margin-top: 20px;">
                            <button type="button" id="btn-cancel-modal" class="btn" style="background: #e5e7eb; margin-right: 10px;">Cancelar</button>
                            <button type="submit" class="btn btn-success">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        `;

        this.renderTabelaPlano(container.querySelector('#tbody-plano'));

        // -- LOGIC --
        const modal = container.querySelector('#modal-nova-conta');
        const form = container.querySelector('#form-nova-conta');
        const selPai = container.querySelector('#pc-pai');
        const inpCod = container.querySelector('#pc-codigo');
        const selNat = container.querySelector('#pc-natureza');

        // Logic: Auto-Generate Code
        selPai.addEventListener('change', () => {
            const parentCode = selPai.value;
            if (!parentCode) return;

            // Inherit Natureza
            const parentOpt = selPai.options[selPai.selectedIndex];
            if (parentOpt.dataset.nat) selNat.value = parentOpt.dataset.nat;

            // Find next child code
            // Filter all existing codes that start with "parentCode." and have exactly 1 more segment
            const children = this.planoContasData.filter(c => c.codigo.startsWith(parentCode + '.') && c.codigo.split('.').length === parentCode.split('.').length + 1);

            let maxSuffix = 0;
            children.forEach(c => {
                const parts = c.codigo.split('.');
                const suffix = parseInt(parts[parts.length - 1]);
                if (suffix > maxSuffix) maxSuffix = suffix;
            });

            const nextSuffix = maxSuffix + 1;
            inpCod.value = `${parentCode}.${nextSuffix}`;
        });

        // Eventos Modal
        container.querySelector('#btn-nova-conta').addEventListener('click', () => {
            modal.style.display = 'flex';
            form.reset();
            delete form.dataset.id;
            modal.querySelector('h3').innerText = 'Nova Conta Contábil';
        });
        container.querySelector('#btn-close-modal').addEventListener('click', () => modal.style.display = 'none');
        container.querySelector('#btn-cancel-modal').addEventListener('click', () => modal.style.display = 'none');

        // SAVE (Insert/Update)
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const payload = {
                codigo: inpCod.value,
                nome: document.getElementById('pc-nome').value,
                tipo: document.getElementById('pc-tipo').value,
                natureza: selNat.value,
                tipo_balanco: document.getElementById('pc-tipo-balanco').value || null
            };

            const btnSub = form.querySelector('button[type="submit"]');
            btnSub.innerText = 'Salvando...'; btnSub.disabled = true;

            let err;
            if (form.dataset.id) {
                const { error } = await window.FazendaRP.supabase.from('financeiro_plano_contas').update(payload).eq('id', form.dataset.id);
                err = error;
            } else {
                const { error } = await window.FazendaRP.supabase.from('financeiro_plano_contas').insert([payload]);
                err = error;
            }

            if (err) {
                alert("Erro ao salvar: " + err.message);
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Conta salva!');
                modal.style.display = 'none';
                this.renderPlanoContas(container); // Reload Full
            }
            btnSub.innerText = 'Salvar'; btnSub.disabled = false;
        });
    },

    renderTabelaPlano: function (tbody) {
        tbody.innerHTML = '';
        // Sort already guaranteed by initial Order By, but we can resort if needed.
        this.planoContasData.forEach((conta) => {
            const nivel = conta.codigo.split('.').length - 1;
            const paddingLeft = nivel * 20;
            // Correção Visual: Apenas GRUPO fica Negrito forte. SUBGRUPO fica médio.
            const fontWeight = conta.tipo === 'GRUPO' ? 'bold' : (conta.tipo === 'SUBGRUPO' ? '500' : 'normal');
            const color = conta.natureza === 'CREDITO' ? '#059669' : '#dc2626';

            const tr = document.createElement('tr');
            tr.innerHTML = `
                <td style="font-weight: ${fontWeight}">${conta.codigo}</td>
                <td style="padding-left: ${paddingLeft + 10}px; font-weight: ${fontWeight}; color: #374151;">
                    ${nivel > 0 ? '↳ ' : ''}${conta.nome}
                </td>
                <td><span class="badge" style="background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1;">${conta.tipo}</span></td>
                <td style="color: ${color}; font-weight: 600; font-size: 0.85em;">${conta.natureza}</td>
                <td style="font-size: 0.8rem; color: #64748b;">${conta.tipo_balanco ? conta.tipo_balanco.replace('_', ' ').toUpperCase() : '-'}</td>
                <td>
                    <button class="btn-edit-pc" data-id="${conta.id}" style="border:none; background:none; cursor:pointer; color: #0ea5e9; font-size:1.1em;" title="Editar"><i class="fas fa-edit"></i></button>
                    <button class="btn-delete-pc" data-id="${conta.id}" style="border:none; background:none; cursor:pointer; color: #ef4444; font-size: 1.1em;" title="Excluir"><i class="fas fa-trash"></i></button>
                </td>
            `;
            tbody.appendChild(tr);
        });

        // Listeners Table (Edit/Delete)
        tbody.addEventListener('click', async (e) => {
            const btnEdit = e.target.closest('.btn-edit-pc');
            const btnDel = e.target.closest('.btn-delete-pc');

            if (btnEdit) {
                const id = parseInt(btnEdit.dataset.id);
                const conta = this.planoContasData.find(c => c.id === id);
                if (conta) {
                    const modal = document.querySelector('#modal-nova-conta');
                    const form = document.querySelector('#form-nova-conta');

                    form.dataset.id = id;
                    document.getElementById('pc-codigo').value = conta.codigo;
                    document.getElementById('pc-nome').value = conta.nome;
                    document.getElementById('pc-tipo').value = conta.tipo === 'CONTA' ? 'ANALITICA' : conta.tipo;
                    document.getElementById('pc-natureza').value = conta.natureza;
                    document.getElementById('pc-tipo-balanco').value = conta.tipo_balanco || '';

                    modal.querySelector('h3').innerText = 'Editar Conta';
                    modal.style.display = 'flex';
                }
            }

            if (btnDel) {
                if (confirm('Tem certeza que deseja excluir esta conta?')) {
                    const id = parseInt(btnDel.dataset.id);
                    const { error } = await window.FazendaRP.supabase.from('financeiro_plano_contas').delete().eq('id', id);
                    if (!error) {
                        window.FazendaRP.Toast.show('success', 'Removido', 'Conta excluída.');
                        this.renderPlanoContas(document.getElementById('financeiro-content'));
                    } else {
                        alert("Erro ao excluir: " + error.message);
                    }
                }
            }
        });
    }

});
